// Modules
import React from "react";
import PropTypes from "prop-types";
import Skeleton from "@material-ui/lab/Skeleton";

// Assets
import "./pills.scss";

const Pills = (props) => {
	const {
		label,
		value,
		loader,
		clssName,
	} = props;

	return (
		<div className={`pills-container ${clssName}`}>
			{loader === true || label === null
				? (
					<Skeleton
						animation="wave"
						variant="text"
						width="10vh"
						className="label"
					/>
				) : <h6 className="label">{label}</h6>}
			<div className="frame">
				{loader === true
					? (
						<Skeleton
							animation="wave"
							variant="text"
							width="10vh"
							className="value"
						/>
					) : <p className="value">{value}</p>}
			</div>
		</div>
	);
};

Pills.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	loader: PropTypes.bool.isRequired,
	clssName: PropTypes.string,
};

Pills.defaultProps = {
	label: null,
	value: null,
	clssName: "",
};

export default Pills;